export default __webpack_public_path__ + "static/media/ramp_walkthrough_5.bb6bc3c9.bin";